const FullDialog = {
  install: (Vue) => {
    Vue.component('FullDialog', () => {
      return import('./components/index.vue')
    })
  }
}

export default FullDialog
